import { useTranslation } from "react-i18next";
import "./coming-soon.scss"

// interface Props {
//   moduleName: string;
// }

const ComingSoonPage = () => {
  const { t } = useTranslation()
  return (
    <div className="coming-soon-page">
      <h1>{t("ComingSoon.hereSoon")}</h1>
      <p>{t("ComingSoon.checkLater")}</p>
    </div>
  );
};

export default ComingSoonPage;
